import type { Product as ProductTrackingData } from '@coursera/event-pulse-types';

import { eventingV3ProductType, extractEventId } from 'bundles/product-card/components/utils/productCardV2Utils';
import type { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

type LearningProduct = (typeof LEARNING_PRODUCTS)[keyof typeof LEARNING_PRODUCTS];

// Flat args rather than a TakeoverData + hit pair: TakeoverCard owns the TakeoverData type, so
// depending on it here would make TakeoverCard <-> this module a cycle.
export type TakeoverTrackingArgs = {
  campaignId: string;
  partnerId?: string;
  placementId?: string;
  cardIndex?: number;
  id?: string;
  name?: string;
  slug?: string;
  productType?: LearningProduct;
  searchedQuery?: string;
};

// Shared by view_takeover_card and click_takeover_card. Lives outside TakeoverCard because the
// click event has to be fired by whoever owns the click -- under the XDP modal that is
// CourseCardXdpTrigger, whose capture handler stops propagation before the CTA's own onClick runs.
export const buildTakeoverTrackingPayload = ({
  campaignId,
  partnerId,
  placementId,
  cardIndex,
  id,
  name,
  slug,
  productType,
  searchedQuery,
}: TakeoverTrackingArgs) => {
  const productTrackingData: ProductTrackingData = {
    id: extractEventId(id) || '',
    ...(name && { name }),
    ...(slug && { slug }),
    ...(productType && { type: eventingV3ProductType(productType) }),
  };

  return {
    takeoverCard: {
      campaignId,
      ...(partnerId && { partnerId }),
      ...(placementId && { placementId }),
      ...(typeof cardIndex === 'number' && { index: cardIndex }),
    },
    product: productTrackingData,
    ...(searchedQuery && { searchedQuery }),
  };
};

export default buildTakeoverTrackingPayload;
